import { BRAND_LOGO, BRAND_NAME } from "@/data/brand";
import { useEffect, useState } from "react";
import { ArrowUpRight, Search, ShoppingBag, UserRound } from "lucide-react";

export default function Header({ cartCount, user, onCart, onAccount }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const findPart = () => {
    setSearchOpen(true);
    document.getElementById("catalog")?.scrollIntoView({ behavior: "smooth" });
    window.setTimeout(() => document.getElementById("catalog-search-input")?.focus(), 450);
  };
  useEffect(() => {
    const handleShortcut = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        findPart();
      }
      if (event.key === "/" && document.activeElement?.tagName !== "INPUT") {
        event.preventDefault();
        findPart();
      }
    };
    window.addEventListener("keydown", handleShortcut);
    return () => window.removeEventListener("keydown", handleShortcut);
  }, []);
  return (
    <header className="site-header" data-testid="header-navigation-bar">
      <a href="#top" className="brand-lockup" data-testid="header-brand-logo-link" aria-label="Bicycle Parts Direct home">
        <img className="brand-logo" src={BRAND_LOGO} alt={BRAND_NAME} />
      </a>
      <nav className="site-nav" aria-label="Primary navigation">
        <a href="#catalog" data-testid="header-catalog-link">Catalogue</a>
        <a href="#matcher" data-testid="header-matcher-link">Fit finder</a>
        <a href="#process" data-testid="header-process-link">How it works</a>
      </nav>
      <div className="header-actions">
        <button className={`header-search ${searchOpen ? "is-active" : ""}`} onClick={findPart} aria-expanded={searchOpen} data-testid="header-search-modal-button"><Search size={15} /> <span>Find a part</span><kbd>⌘K</kbd></button>
        <button className="header-account" onClick={onAccount} data-testid="header-account-button"><UserRound size={16} /><span>{user ? user.name.split(" ")[0] : "Free account"}</span></button>
        <button className="cart-trigger" onClick={onCart} data-testid="header-cart-drawer-button"><ShoppingBag size={17} /><span>Cart</span><b data-testid="header-cart-count">{cartCount}</b></button>
        <a href="#catalog" className="header-arrow" data-testid="header-shop-arrow-link"><ArrowUpRight size={18} /></a>
      </div>
    </header>
  );
}
